/* Amazon insert gift page. The scratch code unlocks its promo code from vc-amazon-gift-codes.json:
   PBKDF2-SHA256 turns the code into a lookup id and an AES-GCM key (same steps as tools/gift_codes_build.py).
   The signup posts Shopify's customer form; Shopify's one-use discount settings stop reuse. */
(function () {
  var root = document.querySelector('[data-vcg]');
  if (!root || !window.crypto || !crypto.subtle) return;

  var copy = JSON.parse(root.querySelector('[data-vcg-copy-text]').textContent);
  var STORE_KEY = 'vcg-reward';
  var codesPromise = null;
  var reward = null;

  function $(sel) { return root.querySelector(sel); }
  function show(step) {
    root.querySelectorAll('[data-vcg-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-vcg-step') !== step;
    });
    var focusEl = root.querySelector('[data-vcg-step="' + step + '"] h1, [data-vcg-step="' + step + '"] h2');
    if (focusEl) { focusEl.setAttribute('tabindex', '-1'); focusEl.focus({ preventScroll: false }); }
  }
  function say(el, text) { el.textContent = text || ''; el.hidden = !text; }
  function save(r) { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(r)); } catch (e) {} }
  function load() { try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }
  function b64(s) { return Uint8Array.from(atob(s), function (c) { return c.charCodeAt(0); }); }
  function hex(bytes) { return Array.prototype.map.call(bytes, function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
  function normalise(code) { return code.replace(/[\s-]/g, '').toUpperCase(); }

  function codes() {
    codesPromise = codesPromise || fetch(root.getAttribute('data-codes-url')).then(function (r) { return r.json(); });
    return codesPromise;
  }

  function unlock(code) {
    return codes().then(function (data) {
      return crypto.subtle.importKey('raw', new TextEncoder().encode(normalise(code)), 'PBKDF2', false, ['deriveBits'])
        .then(function (base) {
          return crypto.subtle.deriveBits({ name: 'PBKDF2', hash: 'SHA-256', salt: b64(data.salt), iterations: data.iter }, base, 384);
        })
        .then(function (buf) {
          var bits = new Uint8Array(buf);
          var entry = data.e[hex(bits.slice(0, 16))];
          if (!entry) return null;
          return crypto.subtle.importKey('raw', bits.slice(16), 'AES-GCM', false, ['decrypt'])
            .then(function (key) { return crypto.subtle.decrypt({ name: 'AES-GCM', iv: b64(entry[0]) }, key, b64(entry[1])); })
            .then(function (plain) { return JSON.parse(new TextDecoder().decode(plain)); });
        });
    });
  }

  function offerTitle(offer) { return offer === 'accessory' ? copy.titleAccessory : copy.title100; }

  function showReward(r) {
    $('[data-vcg-promo]').textContent = r.p;
    $('[data-vcg-reward-text]').textContent = r.o === 'accessory' ? copy.rewardAccessory : copy.reward100;
    var target = root.getAttribute(r.o === 'accessory' ? 'data-shop-accessory' : 'data-shop-100') || '/';
    $('[data-vcg-shop]').href = '/discount/' + encodeURIComponent(r.p) + '?redirect=' + encodeURIComponent(target);
    show('reward');
  }

  /* Step 1: scratch code */
  var codeForm = $('[data-vcg-code-form]');
  var codeMsg = $('[data-vcg-code-msg]');
  var codeBtn = $('[data-vcg-code-btn]');
  codeForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var value = codeForm.code.value;
    if (!normalise(value)) { say(codeMsg, copy.emptyCode); return; }
    var label = codeBtn.textContent;
    codeBtn.disabled = true;
    codeBtn.textContent = copy.checking;
    say(codeMsg, '');
    unlock(value).then(function (r) {
      if (!r) { say(codeMsg, copy.notFound); return; }
      reward = r;
      save(r);
      $('[data-vcg-tags]').value = 'amazon-insert,amazon-insert-' + r.o;
      $('[data-vcg-offer-title]').textContent = offerTitle(r.o);
      show('details');
    }).catch(function () { say(codeMsg, copy.notFound); })
      .then(function () { codeBtn.disabled = false; codeBtn.textContent = label; });
  });

  /* Step 2: details, posted as Shopify's customer form */
  var detailsForm = $('[data-vcg-details-form]');
  var detailsMsg = $('[data-vcg-details-msg]');
  detailsForm.addEventListener('submit', function (e) {
    var order = $('[data-vcg-order]').value.trim();
    var tags = $('[data-vcg-tags]');
    if (order) {
      var m = order.replace(/\s/g, '').match(/^(\d{3})-?(\d{7})-?(\d{7})$/);
      if (!m) { e.preventDefault(); say(detailsMsg, copy.badOrder); return; }
      if (tags.value.indexOf('amz-order-') === -1) tags.value += ',amz-order-' + m[1] + '-' + m[2] + '-' + m[3];
    }
    if (!detailsForm.reportValidity()) { e.preventDefault(); return; }
    /* Post the normal way: Shopify's spam check adds its hCaptcha token on this submit, and a
       background fetch goes without it (400 "Missing CAPTCHA token"). The reward waits in sessionStorage. */
    if (reward) save(reward);
  });

  /* Back from the post (Shopify returns ?customer_posted=true, or a challenge page first) */
  var params = new URLSearchParams(location.search);
  var stored = load();
  if (params.get('customer_posted') === 'true') {
    if (stored) { reward = stored; showReward(stored); }
    else say(codeMsg, copy.lost);
  } else if (stored) { /* reload or form error after the code was unlocked: resume at the form */
    reward = stored;
    $('[data-vcg-tags]').value = 'amazon-insert,amazon-insert-' + stored.o;
    $('[data-vcg-offer-title]').textContent = offerTitle(stored.o);
    show('details');
  } else if (params.get('offer') === 'accessory' || params.get('offer') === '100') {
    $('[data-vcg-title]').textContent = offerTitle(params.get('offer')).replace("You've unlocked", 'Unlock');
  }

  $('[data-vcg-copy]').addEventListener('click', function () {
    var btn = this;
    navigator.clipboard.writeText($('[data-vcg-promo]').textContent).then(function () {
      var label = btn.textContent;
      btn.textContent = copy.copied;
      setTimeout(function () { btn.textContent = label; }, 1500);
    });
  });

  if (codeForm.code && !params.get('customer_posted')) codes();
})();
